
export default {
  name: 'GridItemTags',
  props: {
    product: {
      type: Object,
      required: true,
    },
    collectionKitDiscountPercentage: {
      type: Number,
      required: false,
    },
    margin: {
      type: String,
      required: false,
      default: 'small',
      validator(value) {
        return ['small', 'large'].includes(value);
      },
    },
    earlyAccessEnabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      tags: {
        discount: {
          text_color: theme.settings.discount_tag_text_color,
          bg_color: theme.settings.discount_tag_bg_color,
        },
        sold_out: {
          text: theme.translations.sold_out,
        },
      },
      metaobjectBadges: theme.settings.metaobject_badges || [],
    };
  },
  computed: {
    positions() {
      return ['top-left', 'top-right', 'bottom-left', 'bottom-right'];
    },
    groupedBadgesByPosition() {
      return this.positions
        .map((position) => ({
          name: position,
          badges: this.getBadgesForPosition(position),
        }))
        .filter((position) => position.badges.length > 0);
    },
    hasDiscountToShow() {
      return (
        this.collectionKitDiscountPercentage > 0 ||
        (this.product.compare_at_price > this.product.price &&
          this.product.tags.includes('discount')) ||
        (this.product.compare_at_price > this.product.price &&
          this.product.tags.find((tag) => tag.includes('fixed-discount')))
      );
    },
    discountTag() {
      const discountAmount =
        ((this.product.compare_at_price - this.product.price) * 100) /
        this.product.compare_at_price;

      return Math.round(discountAmount);
    },
    fixedDiscountTag() {
      const fixedDiscountAmount = this.product.tags.find((tag) => tag.includes('fixed-discount'));

      return `-${fixedDiscountAmount?.split(':')[1]}%`;
    },
    positionClasses() {
      return {
        'top-left': {
          small: 'top-0 left-0 items-start mt-8 ml-8',
          large: 'top-0 left-0 items-start mt-16 ml-16',
        },
        'top-right': {
          small: 'top-0 right-0 items-end mt-8 mr-8',
          large: 'top-0 right-0 items-end mt-16 mr-16',
        },
        'bottom-left': {
          small: 'bottom-0 left-0 items-start mb-8 ml-8',
          large: 'bottom-0 left-0 items-start mb-16 ml-16',
        },
        'bottom-right': {
          small: 'bottom-0 right-0 items-end mb-8 mr-8',
          large: 'bottom-0 right-0 items-end mb-16 mr-16',
        },
      };
    },
  },
  methods: {
    convertAlignmentToPosition(alignment) {
      const alignmentMap = {
        'Top Left': 'top-left',
        'Top Right': 'top-right',
        'Bottom Left': 'bottom-left',
        'Bottom Right': 'bottom-right',
      };
      return alignmentMap[alignment] || 'top-right';
    },
    shouldShowMetaobjectBadge(metaobjectBadge) {
      // early-access badge will only appear on product set drawer
      if (metaobjectBadge.productTag === 'early-access') {
        return this.earlyAccessEnabled && this.product.tags.includes('early-access');
      }

      return this.product.tags.includes(metaobjectBadge.productTag);
    },
    getBadgesForPosition(position) {
      const badges = [];

      // Static top left badges
      if (position === 'top-left') {
        if ('available' in this.product && !this.product.available) {
          badges.push({
            key: 'sold-out',
            text: this.tags.sold_out.text,
            class: 'rounded bg-black-400',
            style: {},
          });
        }
      }

      // Static top right badges
      if (position === 'top-right') {
        if (this.hasDiscountToShow) {
          let discountText = '';

          if (this.collectionKitDiscountPercentage > 0) {
            discountText = `-${this.collectionKitDiscountPercentage}%`;
          } else if (
            this.product.compare_at_price > this.product.price &&
            this.product.tags.includes('discount')
          ) {
            discountText = `${this.discountTag}%`;
          } else if (
            this.product.compare_at_price > this.product.price &&
            this.product.tags.find((tag) => tag.includes('fixed-discount'))
          ) {
            discountText = this.fixedDiscountTag;
          }

          if (discountText) {
            badges.push({
              key: 'discount',
              text: discountText,
              class: 'text-inherit',
              style: {
                backgroundColor: this.tags.discount.bg_color,
                color: this.tags.discount.text_color,
              },
            });
          }
        }
      }

      const metaobjectBadges = this.metaobjectBadges.filter(
        (badge) =>
          this.convertAlignmentToPosition(badge.alignment) === position &&
          this.shouldShowMetaobjectBadge(badge)
      );

      metaobjectBadges.forEach((badge) => {
        badges.push({
          key: badge.productTag,
          text: badge.name,
          class: '',
          style: {
            backgroundColor: badge.backgroundColor,
            color: badge.fontColor,
          },
        });
      });

      return badges;
    },
  },
};
